export const SettingsSliderTestIds = {
  settingContainer: 'setting_container',
  settingDescriptor: 'setting_descriptor',
  itemContainer: 'item_container',
  choiceDescriptor: 'choice_descriptor',
  slideToggle: 'slide_toggle'
} as const;
